<template lang="pug">
  .profile-page__content
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Общая информация

      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Название
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="ДОЛ Лето"
                disabled
                )
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal
              .form-elem__title Вместимость
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="200"
                disabled
                )
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal
              .form-elem__title Регион
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Татарстан"
                disabled
                )
          .form__elem
          .form__elem.form__elem_short
            .form-elem.form-elem_horizontal
              .form-elem__title Тип
              .form-elem__main
                select.select
                  option(
                  v-for="item in campTypeList"
                    :value="item.value"
                  ) {{item.text}}
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Теги:
              .form-elem__body
                multiselect.multiselect--lite(
                v-model="value",
                tag-placeholder="Добавьте или выберите тег",
                placeholder="Добавьте или выберите тег",
                label="name",
                track-by="code",
                :options="options",
                :multiple="true",
                :taggable="true",
                @tag="addTag",
                selectLabel="Выбрать"
                deselectLabel="Удалить"
                selectedLabel="Выбран"
                )
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Координаты лагеря
      .profile-section__body
        .form
          .form__elem.form__elem_full
            .coordinate-map
              l-map(
              style="height: 300px; width: 100%"
              :zoom="map.zoom"
              :center="map.center"
              :url="map.url"
              :options='map.options'
              )
                l-tile-layer(
                :url='map.url'
                )
                l-marker(
                :lat-lng="map.center"
                :draggable="true"
                :icon='map.icon'
                @update:latLng="updateCoordinates"
                )

    section.form__elem.form__elem--align-right.form__elem_full
      button.button.button_paint-main.button_long
        .button__text Сохранить
</template>

<script>
import Multiselect from "vue-multiselect";

import L from "leaflet";
import {LMap, LTileLayer, LMarker, LPopup} from "vue2-leaflet";

export default {
  name: "OperatorCampBasic",
  components: {
    Multiselect,
    LMap,
    LTileLayer,
    LMarker
  },
  data() {
    return {
      map: {
        zoom: 10,
        center: [55.8205731562555, 49.1253662109375],
        url: "https://a.tile.openstreetmap.de/{z}/{x}/{y}.png",
        options: {
          attributionControl: false
        },
        icon: L.icon({
          iconUrl: require("../../../../../../assets/images/map/marker.svg"),
          iconSize: [40, 40],
          iconAnchor: [20, 20]
        })
      },
      value: [
        {name: "ДОЛ Лето", code: "camp"},
        {name: "ДОЛ Лето 2", code: "camp2"}
      ],
      options: [
        {name: "ДОЛ Лето", code: "camp"},
        {name: "ДОЛ Лето 2", code: "camp2"},
        {name: "Для детей от 7 до 10", code: "7-10"},
        {name: "Для детей от 10 до 14", code: "10-14"},
        {name: "Спорт", code: "sport"},
        {name: "Компьютеры", code: "computers"}
      ],
      campTypeList: [
        {
          text: "Палаточный",
          value: true
        },
        {
          text: "Стационарный",
          value: false
        }
      ],
      operatorPageData: {
        title: "О лагере",
        description: ""
        // "Здесь вы можете изменить данные своего профиля, следить за статусом заявки, а так же загрузить все необходимы для подачи заявки документы и информацию о детях"
      }
    };
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    updateCoordinates(val) {
      console.log(val);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
